<template>
  <v-form class="col-12">
    <v-text-field
      v-model.trim="$v.user.email.$model"
      prepend-icon="mdi-email"
      name="email"
      autocomplete="off"
      :error-messages="emailError"
      label="E-mail"
      type="email"
    />
    <v-spacer />
    <div class="col-12 d-flex justify-space-between">
      <v-btn text class="caption px-0 py-0" @click="openCadastrar"
        >Cadastre-se</v-btn
      >
      <v-spacer/>
    </div>
    <div class="col-12 d-flex flex-column">
      <v-btn
        :disabled="$v.$invalid || disableSubmit ? true : false"
        color="primary"
        large
        type="submit"
        @click.prevent="submit"
      >
        Continuar
      </v-btn>
    </div>
  </v-form>
</template>


<script>
import { required, email } from 'vuelidate/lib/validators'
export default {
  name: 'Login',
  data: () => ({
    user: {
      email: '',
    },
    listHost:[],
    disableHost:true,
    showPwdBd:false,
    disableBtn: false
  }),
  validations: {
    user: {
      email: {
        required,
        email
      }
    }
  },
  computed: {
    emailError () {
      const errors = [];
      const email = this.$v.user.email;
      if (!email.$dirty) {
        return errors;
      }
      !email.required && errors.push('Email é obrigatório')
      !email.email && errors.push('Email inválido')
      return errors;
    },
    disableSubmit: {
      set (value) {
        this.disableBtn = value
      },
      get () {
        return this.disableBtn
      }
    }
  },
  watch: {
    "user.email" (value) {
      this.$store.dispatch('setEmailRecuperacao', value)
      this.$store.dispatch('setEmail', value)
    },
    "emailLogin"(value){
      if(value!=null & value.length>0) {
        localStorage.setItem('email',value)
        this.user.email = value
        this.$store.dispatch('setEmail', value)
      }
    }
  },
  created(){
    let email = localStorage.getItem('email')
    if (email!=null && email.length>0) {
      this.user.email = email
    }
    if (this.$store.getters.isLogin) {
      this.$router.push({name:'/sacola'})
    }
  },
  props:['emailLogin'],
  methods: {
    openCadastrar () {
      this.$emit('action', { page: 2 });
    },
    openEsqueceuSenha () {
      let input = this.$v.user.email;
      if ((input.$invalid || input.$dirty) && (!input.required || !input.email)) {
        input.$reset()
        input.$touch()
        this.$store.dispatch('setMsgError', 'Email é obrigatório!')
        this.$store.dispatch('setDisplayMsgErr', true)
        return false;
      }
      let data = {
        id: this.user.email,
        pwd: "",
        pwdReset: 1,
        tokenReset: "",
        encrypted: '',
      };

      this.$alertme.signIn(data)
        .then((res) => {
          if (res.data.status != 0) {
            this.$store.dispatch('setMsgError',res.data.msg)
            this.$store.dispatch('setDisplayMsgErr', true)
            return false
          }
          this.$alertme.sendSms('send')
            .then(res => {
              this.$store.dispatch('displayLoading', false);
              if (res.data.status == 0) {
                if (res.data.msg && res.data.msg.length>0) {
                  this.$store.dispatch('MsgSucces', res.data.msg)
                  this.$store.dispatch('displayMsgSuccess',true)
                }
                this.$emit('action', { page: 3 });
                this.$emit('initCountDown', true);
              }
            },
              (e) => {
                this.$store.dispatch('displayLoading', false);
                if (e.response) {
                  this.$store.dispatch('setMsgError', e.response.data.msg)
                  this.$store.dispatch('setDisplayMsgErr', true)
                }
              })
        },
          (e) => {
            if (e.response) {
              this.$store.dispatch('setMsgError',e.response)
              this.$store.dispatch('setDisplayMsgErr', true)
              this.$store.dispatch('resetToken')
            }
          })
    },
    submit () {
      this.disableSubmit = false;
      this.$alertme.listHost({hostId:"",user:this.user.email})
      .then((res) =>{
        this.$alertme.localStoreHostUser(this.user.email, res.data.value)
        this.$emit('action', { page: 5,content:{email:this.user.email,listHost:[ ...res.data.value]} });//proximo passo para login
      })
      .catch((e) => {
            if (e.response) {
              this.$store.dispatch('setMsgError',e.response)
              this.$store.dispatch('setDisplayMsgErr', true)
              this.$store.dispatch('resetToken')
            }
      })
    }
  }
}
</script>